import {
  AiFillGithub,
  AiFillLinkedin,
  AiFillMail,
  AiOutlineArrowDown,
} from "react-icons/ai";
import { Link as ScrollLink } from "react-scroll";
import {
  Box,
  Button,
  Text,
  Image,
  Icon,
  VStack,
  HStack,
  Container,
  Flex,
  Heading,
} from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);
const MotionVStack = motion(VStack);
const MotionHeading = motion(Heading);
const MotionText = motion(Text);

const SOCIALS = [
  {
    label: "GitHub",
    href: "https://github.com/divijgarg",
    icon: AiFillGithub,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/divij-garg-189772212/",
    icon: AiFillLinkedin,
  },
  {
    label: "Email",
    href: "mailto:divijcareer@gmail.com",
    icon: AiFillMail,
  },
];

export default function Begin() {
  return (
    <Box id="home" minH="100vh" display="flex" alignItems="center">
      <Container maxW="5xl" px={{ base: 6, md: 8 }} py={{ base: 20, md: 32 }}>
        <Flex
          direction={{ base: "column", md: "row" }}
          align="center"
          gap={{ base: 8, md: 16 }}
          w="100%"
        >
          <MotionVStack
            spacing={6}
            align={{ base: "center", md: "flex-start" }}
            textAlign={{ base: "center", md: "left" }}
            flex={1}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <MotionText
              fontFamily="mono"
              fontSize={{ base: "2xs", md: "xs" }}
              letterSpacing="0.2em"
              textTransform="uppercase"
              color="whiteAlpha.600"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.15 }}
            >
              Launch Pad Fluids Software · SpaceX
            </MotionText>

            <MotionHeading
              fontSize={{ base: "5xl", md: "6xl", lg: "7xl" }}
              fontWeight="600"
              letterSpacing="-0.045em"
              lineHeight="1"
              color="white"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.25 }}
            >
              Divij Garg
            </MotionHeading>

            {/* <MotionText
              fontSize={{ base: "md", md: "lg" }}
              color="whiteAlpha.700"
              maxW="560px"
              lineHeight="1.7"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.35 }}
            >
              Guidance, navigation and control engineer working on the software
              that gets vehicles off the pad and spacecraft home again.
            </MotionText> */}

            <MotionBox
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.45 }}
              w="100%"
            >
              <VStack
                align={{ base: "center", md: "flex-start" }}
                textAlign={{ base: "center", md: "left" }}
                spacing={3}
              >
                <Text
                  fontFamily="mono"
                  fontSize="2xs"
                  letterSpacing="0.2em"
                  textTransform="uppercase"
                  color="whiteAlpha.500"
                >
                  Education
                </Text>

                <VStack
                  align={{ base: "center", md: "flex-start" }}
                  textAlign={{ base: "center", md: "left" }}
                  spacing={2}
                >
                  <Box>
                    <Text fontSize="sm" color="whiteAlpha.800">
                      B.S. Computer Science &amp; Mathematics
                    </Text>
                    <Text fontSize="sm" color="whiteAlpha.500">
                      University of Illinois Urbana-Champaign · 2026
                    </Text>
                  </Box>

                  <Box>
                    <Text fontSize="sm" color="whiteAlpha.800">
                      M.S. Aerospace Engineering
                    </Text>
                    <Text fontSize="sm" color="whiteAlpha.500">
                      Georgia Institute of Technology · Starting Spring 2027
                    </Text>
                  </Box>
                </VStack>
              </VStack>
            </MotionBox>

            <MotionText
              fontSize="xs"
              color="whiteAlpha.500"
              maxW="560px"
              lineHeight="1.8"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.55 }}
            >
              <Text as="span" fontFamily="mono" letterSpacing="0.1em">
                COURSEWORK ·{" "}
              </Text>
              Estimation of Dynamical Systems (Graduate), Orbital Mechanics,
              Nonlinear Programming, Linear Algebra, Probability, Algorithms,
              Distributed Systems, Systems
            </MotionText>

            <MotionBox
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.65 }}
              pt={2}
            >
              <HStack
                spacing={{ base: 2, md: 3 }}
                flexWrap="wrap"
                rowGap={2}
                justify={{ base: "center", md: "flex-start" }}
              >
                {SOCIALS.map((social) => (
                  <Button
                    key={social.label}
                    as="a"
                    href={social.href}
                    target={
                      social.href.startsWith("mailto:") ? undefined : "_blank"
                    }
                    rel="noopener noreferrer"
                    leftIcon={<Icon as={social.icon} />}
                    variant="outline"
                    size={{ base: "md", md: "sm" }}
                    color="whiteAlpha.800"
                    borderColor="whiteAlpha.300"
                    fontWeight="400"
                    _hover={{
                      bg: "whiteAlpha.100",
                      borderColor: "whiteAlpha.600",
                      color: "white",
                    }}
                    _active={{ bg: "whiteAlpha.200" }}
                  >
                    {social.label}
                  </Button>
                ))}
              </HStack>
            </MotionBox>

            <MotionBox
              pt={6}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
            >
              <ScrollLink to="about" smooth={true} duration={500} offset={-80}>
                <Icon
                  as={AiOutlineArrowDown}
                  w={6}
                  h={6}
                  color="whiteAlpha.500"
                  _hover={{ color: "white", transform: "translateY(4px)" }}
                  transition="all 0.3s"
                  cursor="pointer"
                />
              </ScrollLink>
            </MotionBox>
          </MotionVStack>

          <MotionBox
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
            order={{ base: -1, md: 0 }}
            display="flex"
            justifyContent="center"
            w={{ base: "100%", md: "30%" }}
            flexShrink={0}
          >
            <Image
              src="/Images/earth.png"
              alt="Earth crescent"
              w={{ base: "auto", md: "100%" }}
              h={{ base: "22vh", md: "100%" }}
              maxH={{ base: "200px", md: "none" }}
              objectFit="contain"
              opacity={0.9}
            />
          </MotionBox>
        </Flex>
      </Container>
    </Box>
  );
}
